import { render, staticRenderFns } from "./CardTratamientosSesion.vue?vue&type=template&id=652e2af2&scoped=true"
import script from "./CardTratamientosSesion.vue?vue&type=script&lang=js"
export * from "./CardTratamientosSesion.vue?vue&type=script&lang=js"
import style0 from "./CardTratamientosSesion.vue?vue&type=style&index=0&id=652e2af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e2af2",
  null
  
)

export default component.exports